import { useTranslation } from "react-i18next";
import Helpers from "../../utils/helpers";

const NewCreateInvoiceTop = (props: any) => {
  const { t } = useTranslation();
  const { orderData } = props;
  
  return (
    <div className="grid order-top-color mb-3 px-3">
      <div className="col-12 md:col-3">
        <b>Order #: {orderData.orderID}</b>
      </div>
      <div className="col-12 md:col-3">
        Status: <b>{orderData.orderStatusName}</b>
      </div>
      <div className="col-12 md:col-3">
        {t("ordersummary_order_date")} :{" "}
        <b className="mb-1 font-semibold">
          {new Date(orderData.orderDate).toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric"
          })}
        </b>
      </div>
      <div className="col-12 md:col-3 text-right left-mobile">
        Amount Paid:{" "}
        <b style={{ color: "yellow" }}>
          {Helpers.formatAmountInINR(orderData.amountPaid)}
        </b>
      </div>
    </div>
  );
};

export default NewCreateInvoiceTop;
